import { dashboardApi } from "@/api/dashboardApi";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Card, CardContent, CardHeader, Chip, Divider, IconButton, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { KpiBasicChart } from "../KpiBasicChart/KpiBasicChart";
import Loading from "../feedback/Loading";
import { Link } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";

function StakeholderGroup(props) {
    const { groups = [] } = props;

    return (
        <Box sx={{ display: "flex", gap: "0.2em", flexWrap: "wrap" }}>
            ผู้รับผิดชอบ:{" "}
            {groups.map((group) => {
                let icon = "default";
                switch (group.namespace) {
                    case "User/Executive":
                        icon = <PeopleIcon />;
                        break;
                    case "KPIs/ResponsibleGroup":
                        icon = <WorkIcon />;
                        break;
                    case "user-self-group":
                        icon = <PersonIcon />;
                }

                return <Chip label={group.title} variant="outlined" size="small" icon={icon} />;
            })}
        </Box>
    );
}

export function KpiBasicChartCard(props) {
    const { kpiId, sx } = props;
    const getKpi = dashboardApi.endpoints.getKpiRawDataById.useQuery({
        id: kpiId,
    });
    const kpi = getKpi.data?.data;
    const isLoading = getKpi.isLoading;
    const MemoKpiBasicChart = useMemo(() => <KpiBasicChart kpi={kpi} />, [kpi]);

    const GraphTitle = () => {
        return <Typography variant="h6">{kpi?.title}</Typography>;
    };
    const GraphSubtitle = () => {
        let info = [kpi?.code, `${kpi?.segments?.length ?? "-"} segment`, kpi?.timeframe?.title, kpi?.unit];
        return (
            <Stack direction="row" spacing={0} color="gray" sx={{ marginBottom: 1 }} divider={<Divider>·</Divider>}>
                {info
                    .filter((x) => Boolean(x))
                    .map((_info, index) => (
                        <Typography key={index} variant="subtitle2">
                            {_info}
                        </Typography>
                    ))}
            </Stack>
        );
    };
    const ActionMenu = () => {
        return (
            <Link to={`/kpis/${kpi?.id}`} target="_blank">
                <IconButton>
                    <OpenInNewIcon />
                </IconButton>
            </Link>
        );
    };

    return (
        <Card sx={{ ...sx }}>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <CardHeader
                        title={<GraphTitle />}
                        subheader={<GraphSubtitle />}
                        action={<ActionMenu />}
                    ></CardHeader>
                    <CardContent>
                        {MemoKpiBasicChart}
                        <StakeholderGroup groups={kpi?.stakeholderGroups} />
                    </CardContent>
                </>
            )}
        </Card>
    );
}

export default KpiBasicChartCard;
